import { render } from "./Tourstats.vue?vue&type=template&id=0ec7a4f0&scoped=true"
import script from "./Tourstats.vue?vue&type=script&lang=js"
export * from "./Tourstats.vue?vue&type=script&lang=js"

import "./Tourstats.vue?vue&type=style&index=0&id=0ec7a4f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec7a4f0"]])

export default __exports__